import * as forms from "@client/forms";
import * as analytics from "@client/shared/analytics";
import {useSiteContext} from "@client/site/context";
import {reverse, server} from "@reactivated";
import React from "react";

import {ShareLayout} from "./Share";

export function Template(props: server.journal.views.JoinMeet) {
    // The page posts its own invite code below, so it is not a field the form
    // waits on.
    const {invite_code: _inviteCode, ...fields} = props.form.fields;
    const form = forms.useForm({...props.form, fields});
    const [distinctId, setDistinctId] = React.useState("");
    const ref = React.useRef<HTMLFormElement>(null);

    React.useEffect(() => {
        setDistinctId(analytics.getDistinctId());
    }, []);

    const {request} = useSiteContext();

    const url = new URL(request.url);
    const urlSearchParams = url.searchParams;
    const success = urlSearchParams.get("success");

    if (success == "true") {
        return (
            <ShareLayout
                share={null}
                cta={{
                    title: "View Meet",
                    onClick: () => {
                        window.location.href = reverse("meet_detail", {
                            share_uuid: props.share_uuid,
                        });
                    },
                }}
                title="Confirmation"
            >
                <div className="flex h-full flex-col items-center justify-center gap-2">
                    <h1 className="text-3xl text-pretty">{props.meet_name}</h1>
                    <p>You’ve joined the meet!</p>
                </div>
            </ShareLayout>
        );
    }

    return (
        <ShareLayout
            share={null}
            cta={{title: "Join Meet", onClick: () => ref.current?.submit()}}
            title={`Join ${props.meet_name}`}
        >
            <form
                ref={ref}
                className="flex h-full flex-col items-center gap-4 max-sm:justify-center"
                action="."
                method="POST"
                noValidate
                onSubmit={forms.guard([form])}
            >
                <forms.CSRFToken />
                <forms.FormErrors form={form} />
                <div className="text-center max-sm:-mt-8">
                    <h1 className="text-3xl text-pretty">{props.meet_name}</h1>
                    <p>Enter your details to join</p>
                </div>
                <div className="max-w-[500px] space-y-4">
                    <forms.Fields form={form} fields={["email", "full_name", "name"]} />

                    <div className="flex justify-between gap-2">
                        <forms.Fields
                            form={form}
                            fields={["date_of_birth", "gender"]}
                        />
                    </div>
                </div>

                <input type="hidden" name="invite_code" defaultValue="meet" />
                <input type="hidden" name="distinct_id" defaultValue={distinctId} />
                <input className="hidden" type="submit" />
            </form>
        </ShareLayout>
    );
}
